






















import Vue from 'vue' // eslint-disable-line no-unused-vars
import ContributeModal from '@/components/modals/contribute'

export default {
  name: 'private-modal',
  components: {
    ContributeModal
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    close() {
      this.$store.dispatch('runtime/closeModal')
      this.$store.dispatch('persistent/dissmissNews', new Date())
    },
    open() {
      window.openLink(`https://portal.meteo-parapente.com/tour/`)
      this.$store.dispatch('persistent/dissmissNews', new Date())
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/news.vue